export default "__VITE_ASSET___P7ycbT4__"